// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';

export function isBetweenHours(hour: any, startHour: any, endHour: any) {
	return hour >= startHour && hour <= endHour;
}

export function isHourAfter(hour: any, hourToCheck: any) {
	return hourToCheck && hourToCheck.trim() !== '' && hour > hourToCheck;
}

export function isHourBefore(hour: any, hourToCheck: any) {
	return hourToCheck && hourToCheck.trim() !== '' && hour < hourToCheck;
}

export function isHourAfterOrEquals(hour: any, hourToCheck: any) {
	return hourToCheck && hourToCheck.trim() !== '' && hour >= hourToCheck;
}

export function isHourBeforeOrEquals(hour: any, hourToCheck: any) {
	return hourToCheck && hourToCheck.trim() !== '' && hour <= hourToCheck;
}

export const initialHours = {
	abilitato: false,
	inizioOrario: '08:00',
	fineOrario: '20:00',
	inizioPranzo: '13:00',
	finePranzo: '15:00',
	slotLavorativo: '30',
};

export const getFormattedDateWithHours = (date: Date): string => {
	const options: Intl.DateTimeFormatOptions = {
		weekday: 'long',
		day: 'numeric',
		month: 'long',
		hour: '2-digit',
		minute: '2-digit',
	};
	return date.toLocaleDateString('it-IT', options);
};

export const getListOfYear = () => {
	const currentYear = new Date().getFullYear();
	const years = [];
	for (let year = 2022; year <= currentYear; year++) {
		years.push(year);
	}
	return years;
};

export const getListOfMonth = () => {
	const months = [
		'GENNAIO',
		'FEBBARIO',
		'MARZO',
		'APRILE',
		'MAGGIO',
		'GIUGNO',
		'LUGLIO',
		'AGOSTO',
		'SETTEMBRE',
		'OTTOBRE',
		'NOVEMBRE',
		'DICEMBRE',
	];
	return months;
};

export const getRandomColor = () => {
	return '#' + Math.floor(Math.random() * 16777215).toString(16);
};

// Funzione per scurire un colore
export const darkenColor = (color: any, percent: any) => {
	const num = parseInt(color.slice(1), 16);
	const amt = Math.round(2.55 * percent);
	const R = (num >> 16) - amt;
	const G = ((num >> 8) & 0x00ff) - amt;
	const B = (num & 0x0000ff) - amt;
	return (
		'#' +
		(
			0x1000000 +
			(R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
			(G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
			(B < 255 ? (B < 1 ? 0 : B) : 255)
		)
			.toString(16)
			.slice(1)
	);
};

export const getColorOfStrokeAxis = (darkModeStatus: boolean) => {
	return !darkModeStatus ? 'black' : 'white';
};

export const getColorOfStrokeLines = (darkModeStatus: boolean) => {
	return darkModeStatus ? darkenColor(getRandomColor(), 10) : darkenColor(getRandomColor(), 20);
};

export const getCollaboratorOptions = (collaborators: any) => {
	return useMemo(() => {
		return collaborators.map((collaborator: any) => ({
			value: collaborator.id,
			label: collaborator.nomeCompleto,
		}));
	}, [collaborators]);
};

export const getDefaultValues = (selectedCollaborators: any, collaboratorOptions: any) => {
	return useMemo(() => {
		return selectedCollaborators.map((id: any) => {
			const collaborator = collaboratorOptions.find((option: any) => option.value === Number(id));
			return collaborator ? collaborator : '';
		});
	}, [selectedCollaborators, collaboratorOptions]);
};

export const getServicesOptions = (services: any) => {
	return useMemo(
		() =>
			services.map((service: any) => ({
				value: service.idServizio,
				label: service.nomeServizio,
			})),
		[services],
	);
};

export const getDefaultValuesServices = (selectedServices: any, servicesOptions: any) => {
	return selectedServices.map((id: any) => {
		const service = servicesOptions.find((option: any) => Number(option.value) === Number(id));
		return service ? service : '';
	});
};

export const cellStyleTableRow = (darkModeStatus: boolean) => {
	return { color: darkModeStatus ? 'white' : 'black' };
};

export const tableStyle = (darkModeStatus: boolean) => {
	return {
		borderRadius: '15px',
		overflow: 'hidden',
		boxShadow: darkModeStatus
			? '0px 0px 10px rgba(255, 255, 255, 0.0)'
			: '0px 0px 10px rgba(0, 0, 0, 0.0)',
	};
};

export const DataURIToBlob = (dataURI: string) => {
	const splitDataURI = dataURI.split(',');
	const byteString =
		splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
	const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

	const ia = new Uint8Array(byteString.length);
	for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

	return new Blob([ia], { type: mimeString });
};

export const FileToBlob = (file: any): Promise<Blob> => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			if (reader.result && typeof reader.result === 'string') {
				const dataURI = reader.result;
				const splitDataURI = dataURI.split(',');
				const byteString =
					splitDataURI[0].indexOf('base64') >= 0
						? atob(splitDataURI[1])
						: decodeURI(splitDataURI[1]);
				const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

				const ia = new Uint8Array(byteString.length);
				for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

				const blob = new Blob([ia], { type: mimeString });
				resolve(blob);
			} else {
				reject(new Error('Failed to read file as Data URL'));
			}
		};
		reader.onerror = () => {
			reject(new Error('Failed to read file'));
		};
		reader.readAsDataURL(file);
	});
};

export const formattaData = (dataArray: any) => {
	const [anno, mese, giorno] = dataArray;
	const data = new Date(anno, mese - 1, giorno);
	return data.toLocaleDateString('it-IT', { year: 'numeric', month: 'numeric', day: 'numeric' });
};
export const formatCurrency = (value: number | null) => {
	// Se il valore non è definito o è null, ritorna 0,00 €
	if (value === null || value === undefined) return '€0,00';

	// Usa toLocaleString per gestire il formato numerico con separatori delle migliaia
	const formattedValue = value.toLocaleString('it-IT', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

	return `€${formattedValue}`;
};

export const hasGrant = (userGrants: string[], requiredGrant: string): boolean => {
	return userGrants.includes(requiredGrant);
};
